import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Alert, Box, Button, Chip, IconButton, Menu, MenuItem, Paper, Snackbar, Tab, Tabs, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import SelectBoxSearch from "src/shared/components/select_box_search";
import { typeTaskMock } from "src/shared/mocks/task";
import { ErrorComponent } from "src/shared/pages/error";
import Tasks from "./components/tasks/tasks";
import { Link, useNavigate } from "react-router-dom";
import { PlanningState, useDispatch } from "src/stateManagement/redux";
import { loadAllTasks } from "src/stateManagement/redux/slices/planificacion/asynReducer";
import { PlanningTask } from "src/stateManagement/redux/slices/planificacion/interfaces";
import { useSelector } from "react-redux";
import InventoryIcon from '@mui/icons-material/Inventory';
import ViewListIcon from '@mui/icons-material/ViewList';
import { useLocation } from "react-router-dom";
import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { tableStyles } from "src/shared/util/tableStyles";
import moment from "moment";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ padding: "15px 0px" }}>{children}</Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const internalTabs = [
    { "name": "activies", "states": ['pending', 'inProgress', 'analyzing', 'completed'], icon: <ViewListIcon /> },
    { "name": "archieves", "states": ['discarded', 'blocked'], icon: <InventoryIcon /> },
]

export const Planning = () => {

    const dispatch = useDispatch();

    const location = useLocation();

    const { planingTask } = useSelector(PlanningState);

    const [value, setValue] = useState(0);
    const options: string[] = ["Codigo", "Asignado"];
    const [selectedOption, setSelectedOption] = useState(options[0]);
    const [inputValueFilter, setInputValueFilter] = useState<string>("");
    const [tasks, setTasks] = useState<PlanningTask[]>([]);

    const [selectedRowId, setSelectedRowId] = useState<string | null>(null);

    const [tabValue, setTabValue] = useState(0);

    const [menuDetails, setMenuDetails] = useState<null | HTMLElement>(null);
    const openMenuDetails = Boolean(menuDetails);

    const handleChangeTabValue = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    const [infoAlert, setInfoAlert] = useState({
        open: false,
        message: "",
    })

    const navigate = useNavigate();

    useEffect(() => {
        if (planingTask.length === 0) {
            dispatch(loadAllTasks(
                undefined,
                undefined,
                undefined,
                undefined,
            ));
        }
    }, []);


    useEffect(() => {

        let allTask = planingTask;

        if (inputValueFilter && selectedOption === "Nombre") {
            allTask = allTask.filter(x =>
                x.asignedGroup.toLocaleLowerCase().includes(inputValueFilter?.toLowerCase())
                || x.tecnology?.toLowerCase().includes(inputValueFilter?.toLowerCase()) || x.title?.toLowerCase().includes(inputValueFilter?.toLowerCase()));
        } else if (inputValueFilter && selectedOption === "Asignado") {
            allTask = allTask.filter(x =>
                x.asignedUserName.toLocaleLowerCase().includes(inputValueFilter?.toLowerCase()));
        }

        if (Array.isArray(allTask)) {
            setTasks(allTask);
        }


    }, [planingTask, inputValueFilter]);

    useEffect(() => {
        if (location?.state?.from) {
            if (location.state.from === "taskdeleted") {
                setInfoAlert({ open: true, message: "Tarea borrada" })
                dispatch(loadAllTasks(
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                ));
            }

            if (location.state.from === "taskupdated") {
                setInfoAlert({ open: true, message: "Tarea guardada" })
                dispatch(loadAllTasks(
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                ));
            }


            navigate(location.pathname, { replace: true, state: {} });


        }
    }, [location.state])


    const handleSelectChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setSelectedOption(event.target.value);
        setInputValueFilter("");
    };

    const handleFilterInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValueFilter(event.target.value);
    };

    const handleMenuDetailsClick = (event: React.MouseEvent<HTMLElement>, rowId: string) => {
        setMenuDetails(event.currentTarget);
        console.log({ rowId })
        setSelectedRowId(rowId);
    };

    const handleMenuDetailsClose = () => {
        setMenuDetails(null);
    };

    const columns: GridColDef[] = [
        { field: "type", headerName: "Tipo", width: 90 },
        { field: "tecnology", headerName: "Technologia", width: 120 },
        { field: "asignedGroup", headerName: "Codigo", width: 90 },
        { field: "projectName", headerName: "Campo", width: 130 },
        { field: "asignedUserName", headerName: "usuario Asignado", width: 160 },
        {
            field: "planningStartDate", headerName: "fecha", width: 100, renderCell: (params) => {
                // Format as YYYY-MM-DD
                return params.value
                    ? moment(params.value).format("DD-MM-YYYY")
                    : "";
            },
        },
        { field: "numberOfFieldActivities", headerName: "Ejecutado", width: 110 },
        { field: "numberOfRequirements", headerName: "Meta", width: 70 },
        { field: "advance", headerName: "%", width: 70 },
        { field: "description", headerName: "Comentarios Plan", flex: 1 },
        {
            field: "Unidad", headerName: "Unidad", width: 120, renderCell: (params) => {
                return `${params.row.unit}-${params.row.unitNumber}`
            }
        },
        { field: "vehiclePlate", headerName: "Placa", width: 150 },
        { field: "observations", headerName: "Comentarios Campo", flex: 1 },
        {
            field: "action",
            headerName: "",
            sortable: false,
            filterable: false,
            width: 30,
            align: "center",
            headerAlign: "center",
            renderHeader: () => (
                <IconButton onClick={() => console.log("Header action")}>
                    <MoreVertIcon />
                </IconButton>
            ),
            renderCell: (params) => {

                const rowId = params.row.id;
                return (
                    <>
                        <IconButton onClick={(event)=>handleMenuDetailsClick(event,rowId)}>
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            id="demo-positioned-menu"
                            aria-labelledby="demo-positioned-button"
                            anchorEl={menuDetails}
                            open={openMenuDetails}
                            onClose={handleMenuDetailsClose}
                        >
                            <Link
                                to={`/gto/task/info/${selectedRowId}`}
                                style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                }}
                            >
                            <MenuItem onClick={handleMenuDetailsClose}>
                                Detalles
                            </MenuItem>
                            </Link>
                        </Menu>
                    </>
                );
            },
        },
    ]

    return (
        <Box sx={{ width: "100%" }}>
            {/* Alertas */}
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={infoAlert?.open}
                onClose={() => setInfoAlert({ open: false, message: "" })}
                autoHideDuration={6000}
            >
                <Alert
                    onClose={() => setInfoAlert({ open: false, message: "" })}
                    severity="success"
                    variant="filled"
                >
                    {infoAlert?.message}
                </Alert>
            </Snackbar>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <Box sx={{ width: "100%" }}>
                        <CustomTabPanel value={value} index={0}>
                            <Box>
                                {/* Filtros y boton agregar tarea */}
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <SelectBoxSearch
                                        options={options}
                                        selectedOption={selectedOption}
                                        onOptionChangeSelectBox={
                                            handleSelectChange
                                        }
                                        onValueChangeInput={handleFilterInput}
                                        inputValue={inputValueFilter}
                                    />
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        startIcon={<ControlPointOutlinedIcon />}
                                        onClick={() => navigate("/gto/task/info/0")}
                                    >
                                        Agregar tarea
                                    </Button>
                                </Box>

                                <Box
                                    sx={{
                                        borderBottom: 1,
                                        paddingTop: 2,
                                        display: "flex",
                                        justifyContent: "space-evenly",
                                        borderColor: "divider",
                                    }}
                                >
                                    <Tabs
                                        value={tabValue}
                                        onChange={handleChangeTabValue}
                                        aria-label="basic tabs example"
                                    >
                                        <Tab label="Pendientes" {...a11yProps(0)} />
                                        <Tab
                                            label="En progreso"
                                            {...a11yProps(1)}
                                        />
                                        <Tab
                                            label="Completadas"
                                            {...a11yProps(2)}
                                        />
                                        <Tab
                                            label="Otras"
                                            {...a11yProps(3)}
                                        />
                                    </Tabs>
                                </Box>

                                <CustomTabPanel value={tabValue} index={0}>
                                    <DataGrid
                                        rows={tasks?.filter(x => x.status === 'pending')}
                                        columns={columns}
                                        pageSizeOptions={[10, 20, 50, 100]}
                                        checkboxSelection={false}
                                        sx={{
                                            mt: 2,
                                            height: {
                                                md: `calc(100vh - 395px)`,
                                                lg: `calc(100vh - 395px)`,
                                                xl: `calc(100vh - 400px)`,
                                            },
                                            ...tableStyles,
                                        }}
                                        getRowId={(row) => row.id}
                                    />
                                </CustomTabPanel>

                                <CustomTabPanel value={tabValue} index={1}>
                                    <DataGrid
                                        rows={tasks?.filter(x => x.status === 'inProgress')}
                                        columns={columns}
                                        pageSizeOptions={[10, 20, 50, 100]}
                                        checkboxSelection={false}
                                        sx={{
                                            mt: 2,
                                            height: {
                                                md: `calc(100vh - 395px)`,
                                                lg: `calc(100vh - 395px)`,
                                                xl: `calc(100vh - 400px)`,
                                            },
                                            ...tableStyles,
                                        }}
                                        getRowId={(row) => row.id}
                                    />
                                </CustomTabPanel>

                                <CustomTabPanel value={tabValue} index={2}>
                                    <DataGrid
                                        rows={tasks?.filter(x => x.status === 'completed')}
                                        columns={columns}
                                        pageSizeOptions={[10, 20, 50, 100]}
                                        checkboxSelection={false}
                                        sx={{
                                            mt: 2,
                                            height: {
                                                md: `calc(100vh - 395px)`,
                                                lg: `calc(100vh - 395px)`,
                                                xl: `calc(100vh - 400px)`,
                                            },
                                            ...tableStyles,
                                        }}
                                        getRowId={(row) => row.id}
                                    />
                                </CustomTabPanel>

                                <CustomTabPanel value={tabValue} index={3}>
                                    <DataGrid
                                        rows={tasks?.filter(x => !['pending', 'inProgress', 'completed'].includes(x.status))}
                                        columns={columns}
                                        pageSizeOptions={[10, 20, 50, 100]}
                                        checkboxSelection={false}
                                        sx={{
                                            mt: 2,
                                            height: {
                                                md: `calc(100vh - 395px)`,
                                                lg: `calc(100vh - 395px)`,
                                                xl: `calc(100vh - 400px)`,
                                            },
                                            ...tableStyles,
                                        }}
                                        getRowId={(row) => row.id}
                                    />
                                </CustomTabPanel>
                            </Box>
                        </CustomTabPanel>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Planning;
